/* eslint max-len: ["error", { "code": 160 }] */
/* eslint no-underscore-dangle: ["error", { "allow": ["_id", "_loadMore", "_sentMessagesUpdates", "_createMessage", "_count", "_messagesIds", "_messages"] }] */
import _ from 'lodash';
import Immutable from 'immutable';
import { EventEmitter } from 'events';
import assign from 'object-assign';
import AppDispatcher from '../dispatcher/AppDispatcher';
import Constants from '../constants/Constants';

const { ActionTypes } = Constants;

const CHANGE_EVENT = 'change';

const Message = Immutable.Record({ // eslint-disable-line babel/new-cap
  _id: undefined, // Vēstules ID
  member_id: undefined, // Lietotāja ID ar kuru ir sarakste
  sender_id: undefined, // Sūtītāja ID
  created: undefined, // izveides laiks
  updated: undefined, // atjaunots statuss, piem., izlasīta vēstule
  text: undefined,
  read: false, // vai izlasīta vēstule
  deleted: false,
  reported: false, // vai ir ziņots par konkrēto vēstuli
  hidden: false, // vai vēstuli jāpaslēpj
  report_status: null, // saglabā ziņojot, 'success' vai 'error'
});

let _messages = {}; // vēstules _messages{'member_id'}[Visas member_id vēstules Immutable list]
let _messagesIds = {}; // vēstuļu id vērtības
// Katram lietotājam
// UserId / conversationId : {
//   loadMore: 4 // cik vēstules ielasītas, kad nospiests "load more"
//   openConversation: 4 // cik vēstules ielasītas pie sarakstes atvēršanas
// }
let _count = {};
let _createMessage = false; // vai tiek pievienota jauna vēstule, līdz MESSAGES_LOAD_SUCCESS ir TRUE
let _sentMessagesUpdates = {}; // katram lietotājam glabā vērtību, kad atjaunota informācija par izsūtītajām vēstulēm
let _loadMore = false; // vai ir nospiesta loadMore poga

let _convosLoading = false;
let _failedUpdateCount = 0;

let _loadFailMessage = '';

//
let _webSocket = null;

const MessageStore = assign({}, EventEmitter.prototype, {

  /**
  * $Events
  */

  emitChange() {
    this.emit(CHANGE_EVENT);
  },

  /**
  * @param {function} callback
  */
  addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback);
  },

  /**
  * @param {function} callback
  */
  removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback);
  },

  /**
  * $Set
  */

  /**
  * ieliek pazīmi, vai tiek pievienota jauna vēstule
  */
  setCreateMessage(value) {
    _createMessage = value;
  },

  /**
  * no konkrētas sarakstes izsūtītām vēstulēm uzstāda pēdējo update laiku
  */
  setSentMessagesUpdate(memberId) {
    if (!_messages[memberId]) {
      return null;
    }

    _sentMessagesUpdates[memberId] = null;

    // iegūst jaunākās vēstuled updated vērtību
    const lastUpdated = _messages[memberId].max((message) => {
      // izlaiž tās vēstules, kuras nav kā izsūtītās
      if (message.get('sender_id') === memberId) {
        return null;
      }

      return message.get('updated');
    });

    if (lastUpdated.get('updated')) {
      _sentMessagesUpdates[memberId] = lastUpdated.get('updated');
    }

    return true;
  },

  /**
  * Count default vērtības
  */
  setCountDefaults(conversationID) {
    // ja pirmo reizi izsauc, uzliek default vērtības
    if (!_count[conversationID]) {
      _count[conversationID] = {
        loadMore: false,
        openConversation: false,
      };
    }
  },

  /**
  * Uzseto cik vēstules ielasītas pie pirmās atvēršanas
  */
  setOpenConversationCount(conversationID, count) {
    this.setCountDefaults(conversationID);
    _count[conversationID].openConversation = count;
  },

  /**
  * Uzseto cik vēstules ielasītas pie load more
  */
  setLoadMoreCount(conversationID, count) {
    this.setCountDefaults(conversationID);
    _count[conversationID].loadMore = count;
  },

  /**
  * Uzseto vai aktīva/neaktīva load more poga
  */
  setLoadMore(value) {
    _loadMore = value;
  },

  /**
  * Set error message which needs to be shown (currently used when submitting message)
  */
  setLoadFailMessage(value) {
    _loadFailMessage = value;
  },

  /**
  * Set WebSocket
  */
  setWebSocket(value) {
    _webSocket = value;
  },

  /**
  * $Get
  */

  /**
  * pēc lietotāja id atlasa
  */
  getMessages(id) {
    return _messages[id];
  },

  /**
  * visas vēstules
  */
  getAll() {
    return _messages;
  },

  /**
  * No pēdējām pievienotām vēstulēm, atgriež pēdējās, katram lietotājm
  */
  getLastMessagesByMembers(members) {
    // pārbauda vai masīvs un vai nav tukšs
    if (!members.length) {
      return null;
    }

    const messages = {};
    let message = null;
    // iegūst no katra lietotāja pēdējo vēstuli
    _.forEach(members, (memberId) => {
      if (_messages[memberId]) {
        message = _messages[memberId].last();
        if (message) {
          messages[memberId] = message;
        }
      }
    });

    return messages;
  },

  /**
  * atgriež lietotāja pirmo vēstuli
  */
  getFirstMessage(memberId) {
    if (!_messages[memberId]) {
      return null;
    }

    return _messages[memberId].first();
  },

  /**
  * atgriež lietotāja jaunāko vēstuli (pēdējo sarakstā)
  */
  getLastMessage(memberId) {
    if (!_messages[memberId]) {
      return null;
    }

    return _messages[memberId].last();
  },

  /**
  * info par to vai tiek pievienota jauna vēstule un gaida atbildi
  */
  getCreateMessage() {
    return _createMessage;
  },

  /**
  * Atgriež datumu, kad ir pēdējā atjaunotā info par izsūtītām vēstulēm
  */
  getSentMessagesUpdate(conversationID) {
    if (!_sentMessagesUpdates[conversationID]) {
      return null;
    }

    return _sentMessagesUpdates[conversationID];
  },

  /**
  * Iegūst message indekss vērtību no immutable.list()
  */
  getMessageIndex(message) {
    // atgriež -1 , jo findIndex() atgriež -1, ja neatrod vērtību
    if (!message) {
      return -1;
    }

    return _messages[message.member_id].findIndex(item => item.get('_id') === message._id);
  },

  // izdzēš msg ja pievienots pirms saglabāšanas DB
  // TODO If want to use websockets to show messages before they are actually sent..
  // Need to figure out something with errors.
  // How to show errors if there are any (for example too many equal messages sent today) during actual sending process.
  // And.. then remove message which is already shown? Show for a moment and then remove if it's not actually sent?
  // But that would be so strange.
  // So probably can't show message before it's actually sent, because can't know if it's a valid message (for example, not blacklisted), and actually sent.
  /* checkWebsocketMessageIndex(message) {
    if (typeof _messages[message.member_id] == "undefined") {
      return null;
    }

    let index = _messages[message.member_id].findIndex(item => item.get('text') === message.text && item.get('_id').indexOf("websocket_") !== -1);

    if(index != -1) {
      _messages[message.member_id] = _messages[message.member_id].delete(index);
    }
  }, */


  /**
  * No padotajām vēstulēm iegūst masīvu ar lietotāju id vērtībām
  */
  getMemberIdFromMessages(messages) {
    if (_.isEmpty(messages)) {
      return null;
    }

    return _.uniq(_.map(messages, 'member_id'));
  },

  /**
  * Atgriež cik vēstules ielasītas pie pirmās atvēršanas
  */
  getOpenConversationCount(conversationID) {
    if (!_count[conversationID]) {
      return false;
    }
    return _count[conversationID].openConversation;
  },

  /**
  * Atgriež cik vēstules ielasītas pie load more
  */
  getLoadMoreCount(conversationID) {
    if (!_count[conversationID]) {
      return false;
    }
    return _count[conversationID].loadMore;
  },

  /**
  * Atgriež vai aktīva load more poga
  */
  getLoadMore() {
    return _loadMore;
  },

  /**
  * Get error message which needs to be shown (currently used when submitting message)
  */
  getLoadFailMessage() {
    return _loadFailMessage;
  },

  /**
  * Get WebSocket
  */
  getWebSocket() {
    return _webSocket;
  },

  /**
  * $Add
  */

  /**
  * Pievieno vēstuli
  */
  addMessage(message) {
    // vai attiecīgais member_id, jau ir izveidots
    if (!_messages[message.member_id]) {
      // Vēstules tiek glabātas Immutable sarakstā
      _messages[message.member_id] = Immutable.List(); // eslint-disable-line babel/new-cap
    }

    // pievieno vēstuli, ja jau nav pievienota, skatās pēc vēstules id vērtības
    if (!_messagesIds[message._id]) {
      _messagesIds[message._id] = 1;
      // pievieno sarakstam
      _messages[message.member_id] =
        _messages[message.member_id].push(new Message(message));
    }
  },

  /**
  * Pievieno vēstules
  */
  addMessages(messages) {
    if (!messages) {
      return false;
    }

    // lietotāji, kuru vēstulēm notikusi datu pievienošana
    const membersData = {};

    // pievieno vēstules
    messages.forEach(function (message) {
      // Vai pievienoja jaunu vēstuli
      let added = false;

      // vai izsūtītai vēstulei ir norādīts/ atjaunots updated
      let sentUpdated = false;

      // this.checkWebsocketMessageIndex(message);

      // Pievieno vēstuli, ja vēl nav pievienota
      if (!_messagesIds[message._id]) {
        this.addMessage(message);
        added = true;

        // izsūtītajām vēstulēm norādīts updated lauks
        if (message.updated && message.member_id !== message.sender_id) {
          sentUpdated = true;
        }
      } else if ( // atjauno vēstules datus, ja ir atjaunots updated lauks, interesē tikai izsūtītās vēstules
        message.updated
        &&
        message.member_id !== message.sender_id
        &&
        this.getSentMessagesUpdate(message.member_id) < message.updated
      ) {
        this.updateMessage(message);
        sentUpdated = true;
      }

      // pievieno memberIds, lai zinātu, ka notikušas izmaiņas
      if (added || sentUpdated) {
        // ja vēl nav lietotāja dati, tad izveido
        if (!membersData[message.member_id]) {
          membersData[message.member_id] = {
            added,
            sentUpdated,
          };
        } else {
          // atjauno pievienošanas/atjaunošanas datus
          if (added) {
            membersData[message.member_id].added = added;
          }

          if (sentUpdated) {
            membersData[message.member_id].sentUpdated = sentUpdated;
          }
        }
      }
    }, this);

    for (const memberId in membersData) { // eslint-disable-line no-restricted-syntax
      if (Object.prototype.hasOwnProperty.call(membersData, memberId)) {
        // sakārto vēstules katram lietotājam
        // ja ir pievienota vismaz viena jauna vēstule
        if (membersData[memberId].added) {
          this.sortMessages(memberId);
        }

        // atjauno/uzsetot info par izsūtīto vēstuļu update datumiem
        if (membersData[memberId].sentUpdated) {
          this.setSentMessagesUpdate(memberId);
        }
      }
    }

    return true;
  },

  /**
  * $Update
  */

  /**
  * atjauno vēstules objektu, visu pārraksta ar jauno objektu
  */
  updateMessage(message) {
    // nav aizpildīts updated lauks
    if (!message.updated) {
      return false;
    }

    const messageIndex = this.getMessageIndex(message);

    // nav atrasts
    if (messageIndex === -1) {
      return false;
    }

    const memberId = message.member_id;
    const { updated } = message;
    const read = (!!message.read);

    // atrod indeksu un tad aizvieto ar message jaunajiem laukiem (updated un read)
    _messages[memberId] = _messages[memberId].update(messageIndex, updateMessageItem => updateMessageItem.withMutations((updateMessage) => {
      updateMessage.set('updated', updated).set('read', read);
    }));

    return true;
  },

  /**
  * atjauno 'report_status', kas nepieciešams, lai zinātu, vai rādīt flash ziņu (un kādu, 'success' vai 'error')
  */
  updateReportStatus(message, value) {
    const messageIndex = this.getMessageIndex(message);

    // nav atrasts
    if (messageIndex === -1) {
      return false;
    }

    const memberId = message.member_id;

    //
    _messages[memberId] = _messages[memberId].update(messageIndex, updateMessageItem => updateMessageItem.withMutations((updateMessage) => {
      updateMessage.set('report_status', value);
    }));

    return true;
  },

  /**
  * Atjauno visas sarunas vēstules, atzīmējot kā izlasītas
  */
  updateMessagesAsRead(id, updated) {
    if (!id || !updated || !_messages[id]) {
      return false;
    }

    _messages[id].forEach((message, index) => {
      _messages[id] = _messages[id].update(index, message => message.withMutations((updateMessage) => {
        updateMessage.set('updated', updated).set('read', true);
      }));
    });

    return true;
  },

  /**
  * $Delete
  */

  /**
  *  dzēst vēstuli
  */
  deleteMessage(message) {
    const messageIndex = this.getMessageIndex(message);

    // nav atrasts
    if (messageIndex === -1) {
      return false;
    }

    const memberId = message.member_id;

    // esošo sarakstu aizvieto ar jauno, kur izdzēsta attiecīgais elements
    _messages[memberId] = _messages[memberId].delete(messageIndex);

    return true;
  },

  /**
  *  atzīmēt, ka ziņots par vēstuli
  */
  reportMessage(message) {
    const messageIndex = this.getMessageIndex(message);

    // nav atrasts
    if (messageIndex === -1) {
      return false;
    }

    const memberId = message.member_id;

    //
    _messages[memberId] = _messages[memberId].update(messageIndex, messageItem => messageItem.withMutations((updateMessage) => {
      updateMessage.set('reported', true).set('hidden', true);
    }));

    return true;
  },

  /**
  * update message 'hidden' value
  */
  setHidden(message, value) {
    const messageIndex = this.getMessageIndex(message);

    // nav atrasts
    if (messageIndex === -1) {
      return false;
    }

    const memberId = message.member_id;

    //
    _messages[memberId] = _messages[memberId].update(messageIndex, messageItem => messageItem.withMutations((updateMessage) => {
      updateMessage.set('hidden', value);
    }));

    return true;
  },

  /**
  * dzēst visas lietotāja vēstules
  */
  deleteAllMessages(conversationID) {
    // nav pievienotas vēstules
    if (!_messages[conversationID] || !_messages[conversationID].size) {
      return false;
    }

    // vēstuļu id
    const messageIds = _messages[conversationID].map(message => message.get('_id'));

    // dzēst vēstules
    delete _messages[conversationID];

    // dzēst update info
    delete _sentMessagesUpdates[conversationID];

    // dzēst ierakstus no _messagesIds
    messageIds.forEach((messageId) => {
      delete _messagesIds[messageId];
    });

    return true;
  },

  /**
  * Visi globālie mainīgie iztukšoti
  */
  clearData() {
    _messages = {};
    _messagesIds = {};
    _count = {};
    _createMessage = false;
    _sentMessagesUpdates = {};
    _loadMore = false;
  },

  /**
  * $Sort
  */

  /**
  * Sakārto vēstules
  */
  sortMessages(memberId) {
    _messages[memberId] =
      _messages[memberId].sortBy(message => message.get('created'));
  },

  setConversationsLoading: function(value) {
    _convosLoading = value;
  },

  getConversationsLoading: function() {
    return _convosLoading;
  },

  increaseFailedUpdateCount: function() {
    _failedUpdateCount += 1;
  },

  getFailedUpdateCount: function() {
    return _failedUpdateCount;
  }
});

MessageStore.dispatchToken = AppDispatcher.register((action) => {
  switch (action.type) {
    case ActionTypes.CONVERSATIONS_LOAD: {
      MessageStore.setConversationsLoading(true);
      break;
    }
    case ActionTypes.CONVERSATIONS_LOAD_SUCCESS: {
      MessageStore.setConversationsLoading(false);
      break;
    }
    case ActionTypes.MESSAGES_LOAD: {
      if (action.createMessage) {
        MessageStore.setCreateMessage(true);
      }

      if (action.loadMoreClick) {
        MessageStore.setLoadMore(true);
      }
      MessageStore.emitChange();
      break;
    }
    case ActionTypes.CONVERSATIONS_LOAD_FAIL: {
      MessageStore.setConversationsLoading(false);
      MessageStore.increaseFailedUpdateCount();
      break;
    }
    case ActionTypes.MESSAGES_LOAD_SUCCESS: {
      const count = action.messages.length;
      // norāda, cik vēstules ielasītas pie sarakstes atvēršanas
      // kā arī pārbauda, vai jau nav norādīti šie dati
      if (
        action.openConversation
        &&
        action.id
        &&
        MessageStore.getOpenConversationCount(action.id) === false
      ) {
        MessageStore.setOpenConversationCount(action.id, count);
      }
      // load more gadījumā pievieno vēstuļu skaitu, cik ielādētas
      if (action.loadMoreClick && action.id) {
        MessageStore.setLoadMoreCount(action.id, count);
        MessageStore.setLoadMore(false);
      }

      // pievieno vēstules
      if (count > 0) {
        MessageStore.addMessages(action.messages);
      }

      // vēstule pievienota vai arī uzliek default vērtību
      if ((action.loadMoreClick && action.id) || count > 0) {
        MessageStore.setCreateMessage(false);
        MessageStore.emitChange();
      }
      break;
    }
    case ActionTypes.MESSAGES_LOAD_FAIL: {
      MessageStore.setCreateMessage(false);
      if (action.error) {
        MessageStore.setLoadFailMessage(action.error);
      }
      MessageStore.emitChange();
      break;
    }
    case ActionTypes.MESSAGE_DELETE: {
      // dzēst vēstuli
      MessageStore.deleteMessage(action.message);
      MessageStore.emitChange();
      break;
    }
    case ActionTypes.MESSAGE_REPORT: {
      MessageStore.reportMessage(action.message);
      MessageStore.emitChange();
      break;
    }
    case ActionTypes.MESSAGE_REPORT_SUCCESS: {
      MessageStore.updateReportStatus(action.message, 'success');
      MessageStore.emitChange();
      break;
    }
    case ActionTypes.MESSAGE_REPORT_FAIL: {
      MessageStore.updateReportStatus(action.message, 'error');
      MessageStore.emitChange();
      break;
    }
    case ActionTypes.CONVERSATION_CLICK: {
      MessageStore.setLoadMore(false);
      break;
    }
    case ActionTypes.CONVERSATIONS_DELETE: { // dzēst sarakstes
      // iziet katrai cauri un notiek dzēšana
      _.forEach(action.conversations_ids, (conversationId) => {
        // dzēst vēstules
        MessageStore.deleteAllMessages(conversationId);
      });

      break;
    }
    default:
      // do nothing
  }
});

module.exports = MessageStore;
